import Base from "@/api/Base";

export default class Init extends Base
{
	getMethod ()
	{
		return 'POST';
	}

	getUrl ()
	{
		return '/kunde';
	}
}
